import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import moment from 'moment';
import { MovimientosInventarioService } from '../services/movimientos-inventario.service';
import { ProductosService } from '../services/productos.service';

const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-historial-inventario',
  templateUrl: './historial-inventario.component.html',
  styleUrls: ['./historial-inventario.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class HistorialInventarioComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  filtroForm: FormGroup;
  movimientos: any[] = [];
  isLoading = false;

  totalItems = 0;
  pageSize = 25;
  currentPage = 0;

  productosResultados: any[] = [];
  buscandoProducto = false;
  productoSeleccionado: any = null;
  busquedaProducto = '';

  displayedColumns = ['fecha', 'producto', 'tipo', 'anterior', 'cambio', 'nuevo', 'referencia'];

  tiposMovimiento = [
    { value: '', label: 'Todos' },
    { value: 'venta', label: 'Venta' },
    { value: 'restock', label: 'Restock' },
    { value: 'ajuste', label: 'Ajuste' },
  ];

  constructor(
    private fb: FormBuilder,
    private movimientosService: MovimientosInventarioService,
    private productosService: ProductosService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.filtroForm = this.fb.group({
      startDate: [moment().startOf('month').toDate()],
      endDate: [moment().endOf('month').toDate()],
      tipo: ['']
    });
    this.cargarMovimientos();
  }

  cargarMovimientos(page = 0): void {
    const { startDate, endDate, tipo } = this.filtroForm.value;
    if (!startDate || !endDate) return;

    this.currentPage = page;
    this.isLoading = true;

    const params: any = {
      page: page + 1,
      size: this.pageSize,
      sort: 'createdAt',
      direction: 'DESC',
      fechaInicio: moment(startDate).startOf('day').toISOString(),
      fechaFin: moment(endDate).endOf('day').toISOString(),
    };

    if (tipo) params.tipo = tipo;
    if (this.productoSeleccionado) params.productoId = this.productoSeleccionado.id;

    this.movimientosService.getMovimientos(params).subscribe({
      next: (data) => {
        if (Array.isArray(data)) {
          this.movimientos = data;
          this.totalItems = data.length;
        } else {
          this.movimientos = data?.data ?? [];
          this.totalItems = data?.total ?? data?.meta?.total ?? 0;
        }
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error('Error al cargar el historial de inventario');
        this.isLoading = false;
      }
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.cargarMovimientos(event.pageIndex);
  }

  buscarProducto(termino: string): void {
    this.busquedaProducto = termino;
    if (!termino || termino.length < 2) {
      this.productosResultados = [];
      return;
    }
    this.buscandoProducto = true;
    this.productosService.buscarProductos(termino).subscribe({
      next: (productos) => {
        this.productosResultados = productos || [];
        this.buscandoProducto = false;
      },
      error: () => {
        this.buscandoProducto = false;
        this.productosResultados = [];
      }
    });
  }

  seleccionarProducto(producto: any): void {
    this.productoSeleccionado = producto;
    this.busquedaProducto = producto.nombre;
    this.productosResultados = [];
    this.cargarMovimientos(0);
  }

  limpiarProducto(): void {
    this.productoSeleccionado = null;
    this.busquedaProducto = '';
    this.productosResultados = [];
    this.cargarMovimientos(0);
  }

  tipoLabel(tipo: string): string {
    const found = this.tiposMovimiento.find(t => t.value === tipo);
    return found?.label ?? tipo;
  }

  tipoClass(tipo: string): string {
    switch (tipo) {
      case 'venta': return 'tipo-venta';
      case 'restock': return 'tipo-restock';
      case 'ajuste': return 'tipo-ajuste';
      default: return '';
    }
  }

  cambioClass(cambio: number): string {
    if (cambio < 0) return 'cambio-neg';
    if (cambio > 0) return 'cambio-pos';
    return '';
  }

  formatCambio(cambio: number): string {
    if (cambio > 0) return `+${cambio}`;
    return `${cambio}`;
  }
}
